export const URL = "//web-land.pt"


//Para colocar no servidor fica "//web-land.pt"
//web-land.pt
//http://localhost:2001